module.exports = "https://static.wmbcdn.com/uniweb/images/bea76b712be0f5bcd757cd9f8d3e665d.svg";